// Define permanent columns that cannot be deselected
export const PERMANENT_COLUMNS = [
  'studentId',
  'name',
  'contactNo',
  'courseType',
  'course',
  'courseFees',
  'discountAmount',
  'feesCollected',
  'dateOfAdmission',
  'courseFees',
  'pendingFees',
  'pendingFeesDate',
];

// All available columns for the student table
export const ALL_COLUMNS = [
  { key: 'studentId', label: 'Student ID' },
  { key: 'name', label: 'Name' },
  { key: 'email_Id', label: 'E-mail' },
  { key: 'contactNo', label: 'Contact No.' },
  { key: 'ParentNo', label: 'Parent No' },
  { key: 'address', label: 'Address' },
  { key: 'educationLevel', label: 'Education Level' },
  { key: 'educationCourse', label: 'Education Course' },
  { key: 'clg_name', label: 'Clg' },
  { key: 'department', label: 'Department' },
  { key: 'dob', label: 'DOB' },
  { key: 'source', label: 'Source' },
  { key: 'courseType', label: 'Course Type' },
  { key: 'course', label: 'Course' },
  { key: 'courseDuration', label: 'Course Duration' },
  { key: 'batch', label: 'Batch' },
  { key: 'courseFees', label: 'Course Fees' },
  { key: 'discountAmount', label: 'Discount Amount' },
  { key: 'classType', label: 'Class Type' },
  { key: 'learningMode', label: 'Learning Mode' },
  { key: 'demoGivenBy', label: 'Demo Given By' },
  { key: 'demoGivenDate', label: 'Demo Date' },
  { key: 'adminEmpName', label: 'Admin Name' },
  { key: 'adminlocation', label: 'Location' },
  { key: 'adminbranch', label: 'Branch' },
  { key: 'dateOfAdmission', label: 'Date of Admission' },
  { key: 'feesCollected', label: 'Fees Collected' },
  { key: 'pendingFees', label: 'Pending Fees 1' },
  { key: 'pendingFeesDate', label: 'Pending Fees Date 1' },
  { key: 'pendingFees2', label: 'Pending Fees 2' },
  { key: 'pendingFeesDate2', label: 'Pending Fees Date 2' },
  { key: 'pendingFees3', label: 'Pending Fees 3' },
  { key: 'pendingFeesDate3', label: 'Pending Fees Date 3' },
  { key: 'pendingFees4', label: 'Pending Fees 4' },
  { key: 'pendingFeesDate4', label: 'Pending Fees Date 4' },
  { key: 'staffAssigned', label: 'Staff Assigned' },
  { key: 'placementneeded', label: 'Placement Needed' },
  { key: 'studentRequestedLocation', label: 'Student Requested Location' },
  { key: 'studentRequestedBranch', label: 'Student Requested Branch' },
  { key: 'adminFeedback', label: 'Admin Feedback' },
  { key: 'studentProgressStatus', label: 'ProgressStatus' },
  { key: 'studentRequirement', label: 'Student Requirement' }
];

// Function to get all columns with their labels
export const getAllColumns = () => ALL_COLUMNS;

// Payment mode options
export const PAYMENT_MODES = [
  { value: 'Cash', label: 'Cash' },
  { value: 'UPI', label: 'UPI' },
  { value: 'Credit Card', label: 'Credit Card' },
  { value: 'Debit Card', label: 'Debit Card' },
  { value: 'Other', label: 'Other' }
];

// Payment modes that require a reference number
export const REFERENCE_REQUIRED_MODES = ['UPI', 'Credit Card', 'Debit Card'];